import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import icMoreVert from '@iconify/icons-ic/twotone-more-vert';
import icClose from '@iconify/icons-ic/twotone-close';
import icPrint from '@iconify/icons-ic/twotone-print';
import icDownload from '@iconify/icons-ic/twotone-cloud-download';
import icDelete from '@iconify/icons-ic/twotone-delete';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icPerson from '@iconify/icons-ic/twotone-person';
import icGroup from '@iconify/icons-ic/twotone-group';
import icQuestionAnswer from '@iconify/icons-ic/twotone-question-answer';
import icMyLocation from '@iconify/icons-ic/twotone-my-location';
import icLocationCity from '@iconify/icons-ic/twotone-location-city';
import icEditLocation from '@iconify/icons-ic/twotone-edit-location';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  MatAutocompleteSelectedEvent,
  MatAutocomplete,
} from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import icFence from '@iconify/icons-ic/twotone-fence';
import icLogo from '@iconify/icons-ic/twotone-add-photo-alternate';
import icLink from '@iconify/icons-ic/twotone-link';
import icCity from '@iconify/icons-ic/twotone-house-siding';
import icLanguage from '@iconify/icons-ic/twotone-language';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { QuestionsService } from 'src/@vex/services/questionsService/questionsService';
import { WorkFlowService } from 'src/@vex/services/workFlowSettingService/workFlowSetting.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntilDestroy } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';

declare global {
  interface Window {
    preQuestionGroupsData: any;
  }
}
@UntilDestroy()
@Component({
  selector: 'vex-add-new-question',
  templateUrl: './add-new-question.component.html',
  styleUrls: [
    './add-new-question.component.scss',
  ],
  animations: [fadeInUp400ms],
})
export class AddNewQuestionComponent extends BaseComponent implements OnInit {

  // Mat chip declaration start
  visible1 = true;
  selectable1 = true;
  removable1 = true;
  separatorKeysCodes1: number[] = [ENTER, COMMA];
  fruitCtrl1 = new FormControl();
  filteredFruits1: Observable<string[]>;
  fruits1: string[] = [];
  allFruits1: string[] = [];

  visible2 = true;
  selectable2 = true;
  removable2 = true;
  separatorKeysCodes2: number[] = [ENTER, COMMA];
  fruitCtrl2 = new FormControl();
  filteredFruits2: Observable<string[]>;
  fruits2: string[] = [];
  allFruits2: string[] = [];

  visible3 = true;
  selectable3 = true;
  removable3 = true;
  separatorKeysCodes3: number[] = [ENTER, COMMA];
  fruitCtrl3 = new FormControl();
  filteredFruits3: Observable<string[]>;
  fruits3: string[] = [];
  allFruits3: string[] = [];

  visible4 = true;
  selectable4 = true;
  removable4 = true;
  separatorKeysCodes4: number[] = [ENTER, COMMA];
  fruitCtrl4 = new FormControl();
  filteredFruits4: Observable<string[]>;
  fruits4: string[] = [];
  allFruits4: string[] = [];

  // Mat chip declaration end
  groupName;
  recruitFlowData;
  filteredOptions: Observable<String[]>;

  static id = 100;
  validJson;

  form: FormGroup;
  mode: 'create' | 'update' = 'create';

  icMoreVert = icMoreVert;
  icClose = icClose;
  icGroup = icGroup;
  icPrint = icPrint;
  icDownload = icDownload;
  icDelete = icDelete;
  icQuestionAnswer = icQuestionAnswer;
  icPerson = icPerson;
  icMyLocation = icMyLocation;
  icLocationCity = icLocationCity;
  icEditLocation = icEditLocation;
  icPhone = icPhone;
  icFence = icFence;
  icLogo = icLogo;
  icLink = icLink;
  icCity = icCity;
  icLanguage = icLanguage;
  // chips business unit variable
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;
  fruits: string[] = ['Chicago'];
  allFruits: string[] = [
    'Chicago',
    'Clinical & Non-clicnical',
    'Customer Service',
    'EMEA',
    'Fort Collins,Co',
  ];
  stateData: any = [];
  countriesData: any = [];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  // Mat chip declaration start

  @ViewChild('fruitInput1') fruitInput1: ElementRef<HTMLInputElement>;
  @ViewChild('auto1') matAutocomplete1: MatAutocomplete;
  @ViewChild('fruitInput2') fruitInput2: ElementRef<HTMLInputElement>;
  @ViewChild('auto2') matAutocomplete2: MatAutocomplete;
  @ViewChild('fruitInput3') fruitInput3: ElementRef<HTMLInputElement>;
  @ViewChild('auto3') matAutocomplete3: MatAutocomplete;
  @ViewChild('fruitInput4') fruitInput4: ElementRef<HTMLInputElement>;
  @ViewChild('auto4') matAutocomplete4: MatAutocomplete;
  @ViewChild('fruitInput5') fruitInput5: ElementRef<HTMLInputElement>;
  @ViewChild('auto5') matAutocomplete5: MatAutocomplete;

  // Mat chip declaration end

  base64File: string = null;
  filename: string = null;

  isPublic: string = "1";


  // knock out array
  question_type;
  knockOutList_0 = [{
    item: 'Text', value: 'Text'
  }];
  knockOutList_1 = [
    { item: 'Yes', value: 'Yes' },
    { item: 'No', value: 'No' }
  ];
  knockOutList_2 = [
    { item: 'Yes', value: 'Yes' },
    { item: 'No', value: 'No' },
    { item: 'Not Applicable', value: 'Not Applicable' }
  ];
  knockOutList_3 = [
    { item: 'Less than 1', value: 'Less than 1' },
    { item: '1-2', value: '1-2' },
    { item: '3-5', value: '3-5' },
    { item: '6-9', value: '6-9' },
    { item: '+10', value: '+10' }
  ];
  knockOutList_4 = [{
    item: '1 to 5', value: '1 to 5'
  }];
  knockOutList_5 = [
    { item: 'None', value: 'None' },
    { item: 'Basic', value: 'Basic' },
    { item: 'Intermidiate', value: 'Intermidiate' },
    { item: 'Advanced', value: 'Advanced' }
  ];
  knockOutList_6 = [
    { item: 'No Experience', value: 'No Experience' },
    { item: 'SomeExperience', value: 'SomeExperience' },
    { item: 'Moderate Experience', value: 'Moderate Experience' },
    { item: 'Extensive Experience', value: 'Extensive Experience' }
  ];
  knockOutList_7 = [
    { item: 'None', value: 'None' },
    { item: '6 month to one year', value: '6 month to one year' },
    { item: 'over a year', value: 'over a year' }
  ];
  knockOutList_8 = [
    { item: '1-5', value: '1-5' },
    { item: '5-10', value: '5-10' },
    { item: 'more than 10', value: 'more than 10' }
  ];
  knockOutList_9: any = [];
  knockOutList_10: any = [];
  knockOutList_11: any = [];
  knockOutList_12: any = [];

  knockOutData: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public defaults: any,
    private dialogRef: MatDialogRef<AddNewQuestionComponent>,
    private fb: FormBuilder,
    private _questionsService: QuestionsService,
    private _workFlowService: WorkFlowService,
    public translate: TranslateService,
    public snackbar: MatSnackBar,
  ) {
    super(snackbar, translate);
  }

  ngOnInit() {
    this.getRecruitWorkFlowData();
    this.form = this.fb.group({
      question: [null || ''],
      order: [null || ''],
      groupName: [null || ''],
      questionType: [null || ''],
      answerRequired: [null || ''],
      knockOutAnswer: [null || ''],
      dispositionFlow: [null || ''],
      displayType: [null || ''],
      checkList: [null || ''],
      customRadio: [null || ''],
      customSelect: [null || ''],
      customMultiSelect: [null || '']
    });
    this._questionsService.getPreQuestionGroups().subscribe((res) => {
      window.preQuestionGroupsData = res;
      if (window.preQuestionGroupsData) {
        this.filteredOptions = this.form.controls.groupName.valueChanges.pipe(
          startWith(''),
          map((value) => this._filterGroup(value))
        );
      }
    });

    // Mat chip declaration start
    this.filteredFruits1 = this.form.controls.checkList.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter1(fruit) : this.allFruits1.slice()));

    this.filteredFruits2 = this.form.controls.customRadio.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter2(fruit) : this.allFruits2.slice()));

    this.filteredFruits3 = this.form.controls.customSelect.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter3(fruit) : this.allFruits3.slice()));

    this.filteredFruits4 = this.form.controls.customMultiSelect.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter4(fruit) : this.allFruits4.slice()));

    // Mat chip declaration end
  }

  private _filterGroup(value: any): any[] {
    const filterValue = value;
    return window.preQuestionGroupsData.filter(
      (option) => option.qcatname.toLowerCase().indexOf(filterValue) === 0
    );
  }

  // Mat chip function start 
  add1(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits1.push(value.trim());

    }

    // Reset the input value
    if (input) {
      input.value = '';
      if (this.question_type === '9') {
        if (this.fruits1) {
          this.knockOutData = [];
          this.fruits1.map(data => {
            const checklists = { item: data, value: data }
            this.knockOutList_9.push(checklists);
          })
          this.knockOutData = _.uniqBy(this.knockOutList_9, 'item');;
        }
      }
    }

    this.form.controls.checkList.setValue(null);
  }

  remove1(fruit: string): void {
    const index = this.fruits1.indexOf(fruit);

    if (index >= 0) {
      this.fruits1.splice(index, 1);
    }
  }

  selected1(event: MatAutocompleteSelectedEvent): void {
    this.fruits1.push(event.option.viewValue);
    this.fruitInput1.nativeElement.value = '';
    this.form.controls.checkList.setValue(null);
  }

  private _filter1(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits1.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  add2(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits2.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
      if (this.question_type === '10') {
        if (this.fruits2) {
          this.knockOutData = [];
          this.fruits2.map(data => {
            const radioLists = { item: data, value: data }
            this.knockOutList_10.push(radioLists);
          })
          this.knockOutData = _.uniqBy(this.knockOutList_10, 'item');;
        }
      }
    }

    this.form.controls.customRadio.setValue(null);
  }

  remove2(fruit: string): void {
    const index = this.fruits2.indexOf(fruit);

    if (index >= 0) {
      this.fruits2.splice(index, 1);
    }
  }

  selected2(event: MatAutocompleteSelectedEvent): void {
    this.fruits2.push(event.option.viewValue);
    this.fruitInput2.nativeElement.value = '';
    this.form.controls.customRadio.setValue(null);
  }

  private _filter2(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits2.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  add3(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits3.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
      if (this.question_type === '11') {
        if (this.fruits3) {
          this.knockOutData = [];
          this.fruits3.map(data => {
            const selectLists = { item: data, value: data }
            this.knockOutList_11.push(selectLists);
          })
          this.knockOutData = _.uniqBy(this.knockOutList_11, 'item');;
        }
      }
    }

    this.form.controls.customSelect.setValue(null);
  }

  remove3(fruit: string): void {
    const index = this.fruits3.indexOf(fruit);

    if (index >= 0) {
      this.fruits3.splice(index, 1);
    }
  }

  selected3(event: MatAutocompleteSelectedEvent): void {
    this.fruits3.push(event.option.viewValue);
    this.fruitInput3.nativeElement.value = '';
    this.form.controls.customSelect.setValue(null);
  }

  private _filter3(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits3.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  add4(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits4.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
      if (this.question_type === '12') {
        if (this.fruits4) {
          this.knockOutData = [];
          this.fruits4.map(data => {
            const multiSelectLists = { item: data, value: data }
            this.knockOutList_12.push(multiSelectLists);
          })
          this.knockOutData = _.uniqBy(this.knockOutList_12, 'item');;
        }
      }
    }

    this.form.controls.customMultiSelect.setValue(null);
  }

  remove4(fruit: string): void {
    const index = this.fruits4.indexOf(fruit);

    if (index >= 0) {
      this.fruits4.splice(index, 1);
    }
  }

  selected4(event: MatAutocompleteSelectedEvent): void {
    this.fruits4.push(event.option.viewValue);
    this.fruitInput4.nativeElement.value = '';
    this.form.controls.customMultiSelect.setValue(null);
  }

  private _filter4(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits4.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }
  // Mat Chip function end

  getQuetionType(q_type) {
    this.question_type = q_type;
    if (q_type === '0') {
      this.knockOutData = this.knockOutList_0;
    }
    if (q_type === '1') {
      this.knockOutData = this.knockOutList_1;
    }
    if (q_type === '2') {
      this.knockOutData = this.knockOutList_2;
    }
    if (q_type === '3') {
      this.knockOutData = this.knockOutList_3;
    }
    if (q_type === '4') {
      this.knockOutData = this.knockOutList_4;
    }
    if (q_type === '5') {
      this.knockOutData = this.knockOutList_5;
    }
    if (q_type === '6') {
      this.knockOutData = this.knockOutList_6;
    }
    if (q_type === '7') {
      this.knockOutData = this.knockOutList_7;
    }
    if (q_type === '8') {
      this.knockOutData = this.knockOutList_8;
    }
    if (q_type === '9') {
      this.knockOutData = [];
      this.knockOutList_9 = [];
      if (this.fruits1) {
        this.knockOutData = [];
        this.fruits1.map(data => {
          const checklists = { item: data, value: data }
          this.knockOutList_9.push(checklists);
        })
        this.knockOutData = this.knockOutList_9;
      }
    }
    if (q_type === '10') {
      this.knockOutData = [];
      this.knockOutList_10 = [];
      if (this.fruits2) {
        this.knockOutData = [];
        this.fruits2.map(data => {
          const radioLists = { item: data, value: data }
          this.knockOutList_10.push(radioLists);
        })
        this.knockOutData = this.knockOutList_10;
      }
    }
    if (q_type === '11') {
      this.knockOutData = [];
      this.knockOutList_11 = [];
      if (this.fruits3) {
        this.knockOutData = [];
        this.fruits3.map(data => {
          const selectLists = { item: data, value: data }
          this.knockOutList_11.push(selectLists);
        })
        this.knockOutData = this.knockOutList_11;
      }
    }
    if (q_type === '12') {
      this.knockOutData = [];
      this.knockOutList_12 = [];
      if (this.fruits4) {
        this.knockOutData = [];
        this.fruits4.map(data => {
          const multiSelectLists = { item: data, value: data }
          this.knockOutList_12.push(multiSelectLists);
        })
        this.knockOutData = this.knockOutList_12;
      }
    }
  }
  createQuestion() {
    const foundIndex = _.findIndex(window.preQuestionGroupsData, { qcat_id: this.form.value.groupName });
    let questionBody: any = [];
    if (foundIndex >= 0) {
      questionBody = {
        "question": {
          "Question": this.form.value.question,
          "JQ_order": this.form.value.order,
          "JQ_saveiskill": "",
          "JQ_type": this.form.value.questionType,
          "JQ_selectlong": "",
          "JQ_required": this.form.value.answerRequired,
          "JQ_knockoutanswer": this.form.value.knockOutAnswer,
          "JQ_knockoutflow": this.form.value.dispositionFlow,
          "JQ_internal": this.isPublic,
          "AFlag": 1
        },
        "qcat_id": this.form.value.groupName
      }
    } else {
      questionBody = {
        "question": {
          "Question": this.form.value.question,
          "JQ_order": this.form.value.order,
          "JQ_saveiskill": "",
          "JQ_type": this.form.value.questionType,
          "JQ_selectlong": "",
          "JQ_required": this.form.value.answerRequired,
          "JQ_knockoutanswer": this.form.value.knockOutAnswer,
          "JQ_knockoutflow": this.form.value.dispositionFlow,
          "JQ_internal": this.isPublic,
          "AFlag": 1
        },
        "qcatname": this.form.value.groupName
      }
    }

    this._questionsService.addPreQuestion(questionBody).subscribe((res) => {
      if (res.message === 'Added Success!') {
        this.showSuccess(this.translate.instant('NEW_QUESTION_ADDED_SUCCESSFULLY'));
        this.dialogRef.close();
      }
    }, (err) => {
      console.log(err);
    });
  }

  getRecruitWorkFlowData() {
    this._workFlowService.getWorkFlowData().subscribe((res) => {
      this.recruitFlowData = res;
    })
  }
  getTitle(value?: number) {
    this.groupName = value ? window.preQuestionGroupsData.find(_ => _.qcat_id === value).qcatname : undefined;
    return value ? window.preQuestionGroupsData.find(_ => _.qcat_id === value).qcatname : undefined;
  }
}
